import { useState } from 'react';

const faqs = [
  {
    pregunta: '¿Cuáles son los horarios de atención de Gimnasio Energy?',
    respuesta: 'Atendemos en horarios continuos de lunes a sábado para que puedas entrenar a tu ritmo sin interrupciones:',
    puntos: [
      'Lunes a Viernes: 8:30 a.m. a 1:30 p.m. - 4:00 p.m. a 10:00 p.m.',
      'Sábados: 8:30 a.m. a 2:00 p.m. - 4:00 p.m. a 8:30 p.m.',
      'Domingos y Feriados: Consultar horarios especiales publicados en nuestras redes sociales.'
    ]
  },
  {
    pregunta: '¿Dónde están ubicados y cómo puedo llegar?',
    respuesta: 'Estamos ubicados en una zona céntrica y de fácil acceso en la ciudad de Huánuco:',
    puntos: [
      'Dirección: Jr. Aguilar 771 - Piso 2, Huánuco, Perú.',
      'Referencia: A pocas cuadras de la Plaza de Santo Domingo.',
    ],
    enlace: {
      texto: 'Ver ubicación exacta en Google Maps',
      url: 'https://maps.app.goo.gl/3kVH4nAgpWf4LsNLA'
    }
  },
  {
    pregunta: '¿Cuentan con instructores y rutina para principiantes en el gym?',
    respuesta: '¡Por supuesto! Si es tu primera vez en el gym o estás retomando el entrenamiento:',
    puntos: [
      'Instructores en sala: Disponibles para enseñarte la técnica correcta en máquinas y pesos libres.',
      'Plataforma web personalizada: Podrás consultar tu plan de ejercicios en el gym, ver qué rutina te toca cada día y registrar tu progreso.',
      'Planificación a medida: Diseñamos tu rutina de ejercicios para mujeres o rutina de ejercicios para hombres adaptada a si buscas bajar de peso o ganar músculo.',
      'Asesoría fitness y nutricional: Contamos con guía alimenticia y seguimiento para potenciar tus resultados.'
    ]
  },
  {
    pregunta: '¿Qué membresías y facilidades de pago tienen disponibles?',
    respuesta: 'Tenemos una amplia variedad de planes pensados para adaptarse a tu presupuesto y disponibilidad:',
    puntos: [
      'Planes flexibles: Pases por día, semana, mes, trimestre y planes con descuentos.',
      'Medios de pago: Efectivo, transferencias bancarias y billeteras digitales (Yape / Plin).'
    ],
    enlaceInterno: {
      texto: 'Explorar nuestra sección de Tarifas',
      href: '#tarifas'
    }
  },
  {
    pregunta: '¿Cómo puedo acceder a mi plan de ejercicios en el gym desde mi celular?',
    respuesta: 'Puedes consultar todo nuestro catálogo de rutinas de ejercicio directamente desde esta web o nuestra aplicación:',
    puntos: [
      'Guía visual con videos: Demostraciones y técnica de ejercicios para principiantes por cada grupo muscular (pecho, espalda, piernas, etc.).',
      'Modo entrenamiento: Crea tu plan de ejercicios o pide ayuda a tu instructor para llevar el control de tus series, repeticiones y medidas corporales desde tu móvil.'
    ],
    enlaceInterno: {
      texto: 'Ir a App movil',
      href: '/descargar-app'
    }
  }
];

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(0); // Primera abierta por defecto como en la imagen de ejemplo

  const toggleFaq = (index) => {
    setOpenIndex(prev => (prev === index ? null : index));
  };

  return (
    <section id="faq" className="bg-black py-16 md:py-24 px-4 md:px-8 border-t border-neutral-900 relative z-10">
      <div className="max-w-4xl mx-auto">
        <h2 className="anton-font text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white uppercase leading-tight tracking-normal mb-10 md:mb-12 text-left">
          Preguntas Frecuentes
        </h2>

        <div className="border-t border-neutral-800">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                key={index}
                className="border-b border-neutral-800 transition-colors"
              >
                {/* Botón de la pregunta */}
                <button
                  type="button"
                  onClick={() => toggleFaq(index)}
                  className="w-full py-5 md:py-6 flex items-center justify-between text-left group cursor-pointer focus:outline-none"
                  aria-expanded={isOpen}
                >
                  <span className="text-white text-base md:text-xl font-bold pr-6 group-hover:text-cyan-400 transition-colors leading-snug">
                    {faq.pregunta}
                  </span>

                  <span className="flex-shrink-0 ml-4 flex items-center justify-center w-8 h-8">
                    {isOpen ? (
                      /* Icono Menos (-) */
                      <svg
                        className="w-6 h-6 text-cyan-400 transform transition-transform duration-200"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={3}
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M20 12H4" />
                      </svg>
                    ) : (
                      /* Icono Más (+) */
                      <svg
                        className="w-6 h-6 text-white group-hover:text-cyan-400 transform transition-transform duration-200"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={3}
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
                      </svg>
                    )}
                  </span>
                </button>

                {/* Contenido desplegable */}
                {isOpen && (
                  <div className="pb-6 pt-1 text-neutral-300 text-sm md:text-base leading-relaxed animate-fadeIn">
                    <p className="mb-4 text-neutral-200 font-normal">
                      {faq.respuesta}
                    </p>

                    {faq.puntos && faq.puntos.length > 0 && (
                      <ul className="space-y-2.5 mb-4 pl-1">
                        {faq.puntos.map((punto, pIdx) => (
                          <li key={pIdx} className="flex items-start">
                            <span className="inline-block w-2 h-2 rounded-full bg-cyan-400 mt-2 mr-3 flex-shrink-0 shadow-[0_0_8px_rgba(34,211,238,0.6)]"></span>
                            <span className="text-neutral-300">{punto}</span>
                          </li>
                        ))}
                      </ul>
                    )}

                    {/* Enlace externo si existe */}
                    {faq.enlace && (
                      <div className="mt-3">
                        <a
                          href={faq.enlace.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center text-cyan-400 hover:text-cyan-300 font-medium underline underline-offset-4 transition-colors"
                        >
                          {faq.enlace.texto} &rarr;
                        </a>
                      </div>
                    )}

                    {/* Enlace interno si existe */}
                    {faq.enlaceInterno && (
                      <div className="mt-3">
                        <a
                          href={faq.enlaceInterno.href}
                          className="inline-flex items-center text-cyan-400 hover:text-cyan-300 font-medium underline underline-offset-4 transition-colors"
                        >
                          {faq.enlaceInterno.texto} &rarr;
                        </a>
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
